import { gql } from '@nerdwallet/apollo';

export const financialAccountFragment = gql`
  fragment FinancialAccountFragment on FinancialAccount {
    autoRefreshRequired
    balance
    createdAt
    currency
    extra
    financialPortal {
      accountsState
      activeMigration
      alertMessage
      alertName
      alertPriority
      authState
      authStateSetAt
      canonicalInstitutionId
      createdAt
      errorMessage
      errorName
      errorPriority
      id
      identityId
      isActiveSync
      isAutoRefreshing
      isBalanceRefreshing
      isManualRefreshing
      lastRefreshedAt
      marketplaceInstitution {
        iavAdminDeactivated
        iavEnabled
        id
        loginUrl
        logoUrl
        name
      }
      primarySource
      sequenceNumber
      source
      sourceEntityId
      sourceInstitutionId
      transactionsState
      updatedAt
    }
    iavVerified
    id
    isHidden
    lastSyncedAt
    mask
    name
    primarySource
    status
    subtype
    subtypeDetails
    transactionsSyncedAt
    type
    updatedAt
    verificationState
    deleteQueuedAt
    flaggedForClosureAt
  }
`;

export const financialAccountsForUserFragment = gql`
  fragment FinancialAccountsForUserFragment on Query {
    financialAccounts {
      accounts {
        ...FinancialAccountFragment
      }
    }
  }
  ${financialAccountFragment}
`;

export const GET_ACCOUNTS_FOR_USER_QUERY = gql`
  query getFinancialAccounts {
    ...FinancialAccountsForUserFragment
  }
  ${financialAccountsForUserFragment}
`;

export const financialPortalsQuery = gql`
  query GetLinkedFinancialPortalsForFinancialInstitutions {
    linkedFinancialPortals {
      portals {
        accountsState
        authState
        id
        isActiveSync
        isRefreshing
        marketplaceInstitution {
          externalId
          id
          logoUrl
          name
        }
        migrationDetails {
          hasUserConfirmed
        }
        primarySource
        transactionsState
        sourceInstitutionId
        updatedAt
        deleteQueuedAt
      }
    }
  }
`;
